import { Swiper, Pagination}  from 'swiper';

export const roomsFeed = () => {

	let roomsFeedSliders = document.querySelectorAll('.m__rfeed__card-media');
	if(roomsFeedSliders){

		roomsFeedSliders.forEach((roomsFeedSlider) => {

			let roomsFeedSliderSlides 	= roomsFeedSlider.querySelectorAll('.swiper-slide');
			let slideVideos 			= roomsFeedSlider.querySelectorAll('.js__rfeed-video');

			//Trigger the first video on page load
			if(slideVideos.length > 0){
				for (var source in slideVideos[0].children) {
				  var videoSource = slideVideos[0].children[source];
				  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				    videoSource.src = videoSource.dataset.src;
				  }
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

			if(roomsFeedSliderSlides.length > 1){
				//Initialise the slider
				const rfSwiper = new Swiper(roomsFeedSlider, {
					modules: [Pagination],
					centeredSlides : true,
					slidesPerView : 1,
					rewind : true,
					loop: false,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
					pagination: {
				   		el: '.swiper-pagination',
				 	},
				 	autoplay: {
						delay: 2500,
					},
				});

			
			}else{
				//Only 1 slide - don't power up swiper and just manually add the active class (doing a foreach here juuuust in case)
				roomsFeedSliderSlides.forEach((slide) => {
					slide.classList.add('swiper-slide-active');
				})
			}



		})
		
	}

}
